import { connect } from 'react-redux';
import { ServiceDesk } from './service-desk';
import { launchWorkitemInAmplify } from '../../actions/cases.action';
import { codeBenchActions } from '@codametrix/ui-common';

// Service Desk gates UI/permissions on this (packages/service-desk's
// policiesContext.roles) -- it must never decode a JWT for this itself,
// so the host passes its own already-known roles through explicitly.
const buildUserContext = (state: any) => ({
  ...state.ui.context,
  serviceLine: state.ui.serviceLine,
  roles: (state.ui.roles || []).map((role: CMxAPI.SystemRole) => role.roleName)
});

const mapStateToProps = function(state: any): AppProps.ServiceDeskProps {
  return {
    viewType: 'GRID_WIDGET_CASES',
    capabilities: state.capabilities,
    userContext: buildUserContext(state),
    hasAmplifyCaseRunV2Access: state.ui.hasAmplifyCaseRunV2Access
  };
};

const mapDispatchToProps = (dispatch: any): AppProps.ServiceDeskMethods => {
  return {
    openAmplifyCase: (launchConfig: CMxCommonApp.LaunchWorkItemConfig) => {
      dispatch(launchWorkitemInAmplify(launchConfig));
      if (launchConfig.hasAmplifyCaseRunV2Access) {
        dispatch(codeBenchActions.hideSideNavBar());
      }
    }
  };
};

const mapQueueStateToProps = function(state: any): AppProps.ServiceDeskProps {
  return {
    viewType: 'GRID_WIDGET_WORKLIST_SETTINGS',
    userContext: buildUserContext(state)
  };
};

const mapQualityStateToProps = function(state: any): AppProps.ServiceDeskProps {
  return {
    viewType: 'GRID_CODING_QUALITY',
    userContext: buildUserContext(state)
  };
};

const mapQualityAssessmentStateToProps = function(
  state: any
): AppProps.ServiceDeskProps {
  return {
    viewType: 'GRID_QUALITY_ASSESSMENT',
    userContext: buildUserContext(state)
  };
};

const QueueSettings = connect(
  mapQueueStateToProps,
  mapDispatchToProps
)(ServiceDesk);
const WorkList = connect(mapStateToProps, mapDispatchToProps)(ServiceDesk);

const CodingQuality = connect(
  mapQualityStateToProps,
  mapDispatchToProps
)(ServiceDesk);

const QualityAssessment = connect(
  mapQualityAssessmentStateToProps,
  mapDispatchToProps
)(ServiceDesk);

export {
  QueueSettings,
  WorkList,
  CodingQuality,
  QualityAssessment,
  mapStateToProps as worklistMapStateToProps,
  mapDispatchToProps as worklistMapDispatchToProps
};
